import { NgFor, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  output,
  signal,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MarkdownViewerComponent } from '@osos/shared/rich-editor';
import { Divider } from 'primeng/divider';
import { HelpAndDocumentationService } from '../help-and-documentation.service';
import { HelpContent } from '../types';

@Component({
  selector: 'app-help-and-documentation-container',
  imports: [NgFor, NgIf, TranslatePipe, Divider, MarkdownViewerComponent],
  templateUrl: './help-and-documentation-container.component.html',
  styleUrl: './help-and-documentation-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpAndDocumentationContainerComponent {
  readonly helpAndDocumentationService = inject(HelpAndDocumentationService);
  close = output<void>();

  #helper = signal<HelpContent | null>(null);
  readonly helper = this.#helper.asReadonly();
  oldContent = null;
  constructor() {
    // Reset helper to null when content is set to null or changed
    effect(() => {
      const content = this.helpAndDocumentationService.content();
      if (!content || this.oldContent !== content) {
        this.#helper.set(null);
      }
      this.oldContent = content;
    });
  }

  setHelper(helpItem: HelpContent | null): void {
    this.#helper.set(helpItem);
  }

  trackByFn(index: number, item: HelpContent): string {
    return item.title;
  }
}
